<adex-set-password
  *ngIf="loadingModel$ | async"
  [model]="model$ | async"
  (submitForm)="onSubmitForm($event)"
></adex-set-password>
